import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';
import { AdminAndManagement } from './admin-and-management.classes';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';

@Injectable({
    providedIn: 'root'
})
export class AdminAndManagementService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant
    ) {
        this.apiUrl = this.appConstant.getUrl()
    }
    get() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllAdmin/`).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getAdminById(Id: number) {
        return this.httpClient.get(`${this.apiUrl}/getAdminById/` + Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    manageAdminAndManagement(AdminAndManagement: AdminAndManagement) {
        return this.httpClient.post(`${this.apiUrl}/manageAdmin`, AdminAndManagement).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    bulkInsert(AdminData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportAdmin`, AdminData).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    bulkDeleteAdmin(adminData) {
        let params = {
            DataToDelete: adminData
        }
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteAdmin`, params).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    addDepartmentalWork(types) {
        return this.httpClient.post(`${this.apiUrl}/manageDepartmentalWork`, types).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getAllDepartmentalWorks() {
        return this.httpClient.get(`${this.apiUrl}/getAllDepartmentalWork`).pipe(
            map((response: any) => {
                return response.data;
            })
        )
    }
    public getAllDepartmentalWorksKendo(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllDepartmentalWork/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public getAllAdminKendo(reqData): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllAdmin/`,reqData).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    addAttachments(attachments: Attachment[]) {
        return new Promise((resolve, reject) => {
          this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              reject(err);
            });
        });
      }
    
      uploadProfilePicture(data) {
        return new Promise((resolve, reject) => {
          this.httpClient.post(`${this.apiUrl}/uploadProfilePicture`, data).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              reject(err);
            });
        });
      }
}
